<template>
  <div id="recommend">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商品管理&nbsp;/&nbsp;推荐管理</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="推荐列表" name="first">
          <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS' v-if="clearId"></Provinces>
           <el-input class="elinputs" v-model="beginData.name" placeholder="商品名称"></el-input>
            <el-select v-model="beginData.recommendId" placeholder="所属分类" class="elinputs">
                <el-option v-for="item in cidList" :key="item.id" :label="`${item.name}（${item.areasName}）`" :value="item.id">
                </el-option>
            </el-select>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='resets'>重置</el-button>
          </div>
          <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
          </div>
          <el-table :data="tableData" @selection-change="handleSelectionChange" id="exportTab" border stripe style="width: 100%">
              <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="goodsSn" label="商品编号" width="160"></el-table-column>
            <el-table-column prop="goodsName" label="商品名称" min-width="260"></el-table-column>
            <el-table-column prop="recommendName" label="所属分类" width="160"></el-table-column>
            <el-table-column min-width="200" label="缩略图">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl+scope.row.imgUrl" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column min-width="200" label="广告图">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl+scope.row.adUrl" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column prop="areasName" label="所属地区" width="160"></el-table-column>
            <el-table-column label="是否显示" width="160">
              <template slot-scope="scope">
                  <p class="boldfont" v-if="scope.row.enabled">是</p><p class="boldfont" v-if="!scope.row.enabled" style="color:#F56C6C">否</p>
              </template>
            </el-table-column>
            <el-table-column prop="addTime" label="添加时间" min-width="180"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(2,scope.row,'recommend:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'recommend:delete')"><i class="el-icon-delete"></i> 删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="推荐分类" name="second">
          <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSSC' v-if="clearId"></Provinces>
           <el-input class="elinputs" v-model="beginData.cname" placeholder="分类名称"></el-input>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='reset'>重置</el-button>
          </div>
          <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
          </div>
          <el-table :data="tableData2" @selection-change="handleSelectionChange" id="exportTab" border stripe style="width: 100%">
              <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="name" label="分类名称" min-width="120"></el-table-column>
            <el-table-column prop="areasName" label="所属地区" min-width="160"></el-table-column>
            <el-table-column min-width="120" label=" 图标">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl+scope.row.imgUrl" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column prop="sortOrder" label="排序" width="120"></el-table-column>
            <el-table-column label="是否显示" sortable width="160">
              <template slot-scope="scope">
                  <p class="boldfont" v-if="scope.row.enabled">是</p><p class="boldfont" v-if="!scope.row.enabled" style="color:#F56C6C">否</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(2,scope.row,'recommend:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'recommend:delete')"><i class="el-icon-delete"></i> 删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="paging">
        <span>
          共
          <i class="pagingNum">{{total}}</i> 条
        </span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog title="添加/编辑" :visible.sync="dialogFormVisible" @close="dataClose" width="60%" class="block">
        <el-form v-if="activeName == 'first'">
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 所属分类：">
                    <el-select v-model="details.recommendId" placeholder="请选择">
                    <el-option
                    v-for="item in cidList"
                    :key="item.id"
                    :label="`${item.name}（${item.areasName}）`"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 选择商品：">
               <el-input placeholder="点击选择商品" v-model="details.previewName" auto-complete="off" :disabled="true"></el-input><el-button style="margin-left: 2%;" type="primary" @click="getshop">选择商品</el-button>
            </el-form-item>
            <!-- <el-form-item label="* 缩略图：">
                <viewer>
                    <img :src='details.preview' style="width:120px;margin: 14px 0;" />
                </viewer>
            </el-form-item> -->
            <el-form-item label="* 缩略图：" style='margin-bottom: 10px;'>
                <el-upload
                    class="upload-demo"
                    :action="URL"
                    :limit="1"
                    :on-remove="handleRemove2"
                    :on-success="handleAvatarSuccess2"
                    :data="newobj"
                    :file-list="details.imgUrlSlts"
                    name="multipartFile"
                    :headers="newhead"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip"> 选择缩略图，推荐尺寸600*300px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 广告图：" style='margin-bottom: 10px;'>
                <el-upload
                    class="upload-demo"
                    :action="URL"
                    :limit="1"
                    :on-remove="handleRemove1"
                    :on-success="handleAvatarSuccess1"
                    :data="newobj"
                    :file-list="details.adUrls"
                    name="multipartFile"
                    :headers="newhead"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip"> 选择广告图，推荐尺寸600*300px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 是否显示：">
                <el-radio v-model="details.enabled" label=true>是</el-radio>
                <el-radio v-model="details.enabled" label=false>否</el-radio>
            </el-form-item>
        </el-form>
        <el-form v-else>
            <el-form-item label="* 分类名称：">
               <el-input placeholder="请输入分类名称：" v-model="details.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 分类图标：" style='margin-bottom: 10px;'>
                <el-upload
                    class="upload-demo"
                    :action="URL"
                    :limit="1"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                    :data="newobj"
                    ref="upload"
                    :file-list="details.imgUrls"
                    name="multipartFile"
                    :headers="newhead"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip"> 选择图标，推荐尺寸200*200px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi"  class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 排序：">
               <el-input placeholder="数字越大，排名越靠前（请输入正整数）" v-model="details.sortOrder" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 是否置顶：">
                <el-radio v-model="details.isTop" label=true>是</el-radio>
                <el-radio v-model="details.isTop" label=false>否</el-radio>
            </el-form-item>
            <el-form-item label="* 是否显示：">
                <el-radio v-model="details.enabled" label=true>是</el-radio>
                <el-radio v-model="details.enabled" label=false>否</el-radio>
            </el-form-item>
        </el-form>
        <el-dialog title="商品选择" :visible.sync="innerVisible" append-to-body id="datatext" width="60%">
          <el-form>
            <el-table :data="textdata.tableData2" id="exportTab" border style="width: 100%">
              <!-- <el-table-column prop="id" label="商品编号" width="130"></el-table-column> -->
              <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
              <el-table-column prop="name" :show-overflow-tooltip="true" label="商品名称" min-width="130"></el-table-column>
              <el-table-column prop="areasName" label="城市" min-width="130"></el-table-column>
              <el-table-column prop="deliveryAreaName" label="配送区域" min-width="130"></el-table-column>
              <el-table-column prop="supplierName" label="供应商" min-width="130"></el-table-column>
              <el-table-column label="是否预售" min-width="130">
                  <template slot-scope="scope">
                      <p class="boldfont" v-if="scope.row.isSale" style="color:#67C23A">是</p>
                      <p class="boldfont" v-else style="color:#F56C6C">否</p>
                  </template>
              </el-table-column>
              <el-table-column label="配送方式" min-width="130">
                  <template slot-scope="scope">
                      <p class="boldfont" v-if="scope.row.delivery==1">冷链配</p>
                      <p class="boldfont" v-if="scope.row.delivery==2">常温配</p>
                  </template>
              </el-table-column>
              <el-table-column label="缩略图" width="200">
                  <template slot-scope="scope">
                      <viewer>
                          <img class="sfzimg" :src="imgUrl+scope.row.picUrl" />
                      </viewer>
                  </template>
              </el-table-column>
              <el-table-column label="组图" width="200">
                  <template slot-scope="scope">
                      <viewer>
                          <img class="sfzimg" v-for="(item,index) in scope.row.gallery.split(',')" :key="index" :src="imgUrl+item" />
                      </viewer>
                  </template>
              </el-table-column>
              <el-table-column prop="retailPrice" label="原价" min-width="130"></el-table-column>
              <el-table-column prop="discountPrice" label="优惠价" min-width="130"></el-table-column>
              <el-table-column prop="retailPrice" label="结算价" min-width="130"></el-table-column>
              <el-table-column prop="buyNum" label="销量（真）" min-width="130"></el-table-column>
              <el-table-column prop="buyNumFalse" label="销量（假）" min-width="130"></el-table-column>
              <el-table-column prop="stock" label="库存" min-width="130"></el-table-column>
              <el-table-column prop="sortOrder" label="排序" min-width="130"></el-table-column>
              <el-table-column label="状态" sortable width="130">
                  <template slot-scope="scope">
                      <p class="boldfont" v-if="scope.row.isOnSale" style="color:#67C23A">是</p>
                      <p class="boldfont" v-else style="color:#F56C6C">否</p>
                  </template>
              </el-table-column>
              <el-table-column prop="addTime" label="添加时间" min-width="130"></el-table-column>
              <el-table-column prop="updateTime" label="修改时间" width="130"></el-table-column>
              <el-table-column label="操作" fixed="right" width="120">
                  <template slot-scope="scope">
                      <el-button size="mini" type="success" @click="choice(2,scope.row)">
                        <i class="el-icon-edit"></i>选择
                      </el-button>
                  </template>
              </el-table-column>
            </el-table>
            <div class="paging">
                <span>共<i class="pagingNum">{{textdata.total}}</i> 条</span>
                <Paging :gopage="textdata.total" @pag="pags"></Paging>
            </div>
          </el-form>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext';
import Reset from "@/components/Reset";
import Paging from '@/components/Paging';
import Provinces from "@/components/Provinces";
export default {
  name: "recommend",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces
  },
  data() {
    return {
      beginData:{isShows:[{id:0,name:'是'},{id:1,name:'否'}],isTops:[{id:0,name:'是'},{id:1,name:'否'}]},
      tableData: [],
      tableData2:[],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      innerVisible: false,
      details: {isTop:'true',enabled:'true',imgUrlSlts:[],adUrls:[],imgUrls:[]},
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      formname: JSON.stringify({name:'推荐管理',hint:'recommend:export'}),
      cid:'',
      cidList:[],
      URL:`${this.$Public.URL}/api-r/upload/uploadImg`,
      newobj:{type:3},
      newhead:{
            accessToken:JSON.parse(sessionStorage.getItem('userdata')).token
      },
      multipleSelection:[],
      sheng:'',
      shi:'',
      shenglist:[],
      shilist:[],
      status:'',
      activeName: 'first',
      textdata:{tableData2:[],pageNum:1,pageSize:10,total:0},
      clearId:true,
      beginIdfl:'',
      classId:'',
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  watch:{
    tableData2(newV){
      // console.log(123321)
      // default
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
            this.beginData.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.beginData.areaId=this.shilist[0].id
            this.shi=this.shilist[0].id
            this.details.areasId = this.sheng +','+ this.shilist[0].id
            this.details.areasName = this.userdata.areasName
        }
    }
    this.getClass()
  },
  methods: {
    // 获取省市传入的id
    gainSS(i){
        this.beginIdfl = i.id
    },
    // 获取省市传入的id
    gainSSC(i){
        this.classId = i.id
    },
    resets(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('recommend:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(1)
        }else if(i==2){
            if(this.btn.indexOf('recommend:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(2,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('recommend:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choices()
        }else if(i==4){
            this.query()
        }
    },
    //   多选删除
    choices(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            if(this.activeName == 'first'){
              url = `/api-s/deleteRecommendGoods/${arr.join(',')}`
            }else{
              url = `/api-s/deleteRecommend/${arr.join(',')}`
            }
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    // 获取最新分类
    getClass(){
      this.$axios.post(`/api-s/getAllRecommendList/${this.userdata.areasId}`,{}, {headers: { accessToken: this.userdata.token }})
      .then(res => {
          if(res.data.success){
              this.cidList = res.data.recommendInfoList
          }
      });
    },
    // 点击选择获取内容
    choice(x,row){
      this.details.preview = this.imgUrl+row.picUrl
      this.details.goodsId = row.id

      this.details.imgUrl = row.picUrl
      this.details.previewName = row.name
      this.details.link = row.name
      this.innerVisible = false
    },
    pags(val){
        this.textdata.pageNum = val.pageNum
        this.textdata.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.getshop()
    },
    // 获取商品
    getshop(){
      let vidtext = this.$qs.stringify({
          pageNum: this.textdata.pageNum,
          pageSize: this.textdata.pageSize,
          adminAreasId: this.userdata.areasId
      })
      this.$axios.post(`/api-s/getGoodsList`, vidtext, {headers: { accessToken: this.userdata.token }})
      .then(res => {
          if(res.data.success){
              this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                  this.textdata.tableData2 = res.data.pageInfo.list
                  this.textdata.total = res.data.pageInfo.total
              });
              this.fullscreenLoading = false;
              this.innerVisible = true
          }
      });
    },
    handleClick(tab, event) {
      if(this.activeName == 'first'){
        this.begin()
      }else{
        this.classify()
      }
    },
    // 分类列表获取
    classify(){
      let data2 = this.$qs.stringify({
          adminAreasId:this.userdata.areasId,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          name:this.beginData.cname,
          areaId:this.classId,
      })
      this.$axios.post(`/api-s/getRecommendList`, data2, {headers: { accessToken: this.userdata.token }})
      .then(res => {
        this.fullscreenLoading = false;
        if(res.data.success){
            this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
              // this.tableData2 = res.data.pageInfo.list
              this.$set(this,'tableData2',res.data.pageInfo.list)

              this.$forceUpdate()
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
                type: 'success',
                message: res.data.msg
            });
        }
      });
    },
    // 关闭清空内容
    dataClose(){
      if(this.shilist.length==1){
          this.details = {isTop:'true',enabled:'true',imgUrlSlts:[], adUrls:[],imgUrls:[],areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
      }else{
          this.shi = ''
          this.details = {isTop:'true',enabled:'true',imgUrlSlts:[],adUrls:[],imgUrls:[]}
      }
      this.begin()
    },
    change(val) {

    },
    // 提交
    puton(){
      let url = ''
      if(this.details.areasId == undefined || this.details.areasId == ''){
        return this.$message('请选择所属地区')
      }
      if(this.activeName == 'first'){
        if(!this.details.adUrl||!this.details.goodsId||!this.details.imgUrl||!this.details.recommendId){
          return this.$message('请完善必填信息')
        }
        if(this.status == 1){
            url = `/api-s/addRecommendGoods`
        }else if(this.status == 2){
            url = `/api-s/updateRecommendGoods`
        }
      }else{
        if(!this.details.imgUrl||!this.details.name||!this.details.sortOrder){
          return this.$message('请完善必填信息')
        }
        if(this.status == 1){
            url = `/api-s/addRecommend`
        }else if(this.status == 2){
            url = `/api-s/updateRecommend`
        }
      }
      this.fullscreenLoading = true;
      this.$axios.post(url, this.$qs.stringify(this.details), {headers: { accessToken: this.userdata.token }})
      .then(res=>{
        if(res.data.success){
          this.dialogFormVisible = false;
          this.$message({
                type: 'success',
                message: res.data.msg
            });
            // 添加成功，重新拉取数据
            if(this.activeName == 'first'){
                    this.begin();
                  }else{
                    this.classify();
                  }
        }else{
          this.fullscreenLoading = false;
          this.$message(res.data.msg)
        }
      })
    },
    // 地区id
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.details.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                arr.push(x.name)
            }
        })
        this.details.areasName = arr.join(',')
    },
    // 图标处理
    handleRemove(file, fileList) {
        this.details.imgUrl = ''
    },
    handleAvatarSuccess(res, file) {
        this.details.imgUrl = res.url
    },
    // 广告图处理
    handleRemove1(file, fileList) {
        this.details.adUrl = ''
    },
    handleAvatarSuccess1(res, file) {
        this.details.adUrl = res.url
    },
    // 缩略图处理
    handleRemove2(file, fileList) {
        this.details.imgUrl = ''
    },
    handleAvatarSuccess2(res, file) {
        this.details.imgUrl = res.url
    },
    reset() {
      this.clearId = false
      this.$nextTick(function() {
          this.clearId = true
      })
      this.beginData = {isShows:[{id:0,name:'是'},{id:1,name:'否'}],isTops:[{id:0,name:'是'},{id:1,name:'否'}]}
      if(this.activeName == 'first'){
        this.beginIdfl = ''
        this.begin();
      }else{
        this.classId = ''
        this.classify();
      }
    },
    // handleSizeChange(val) {
    //   this.pageSize = val;
    //   this.fullscreenLoading = true;
    //   this.begin();
    // },
    // handleCurrentChange(val) {
    //   this.pageNum = val;
    //   this.fullscreenLoading = true;
    //   this.begin();
    // },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.load()
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name:this.beginData.name,
        areaId:this.beginIdfl,
        recommendId:this.beginData.recommendId,
        adminAreasId: userdata.areasId
      });
      this.$axios
        .post(`/api-s/getRecommendGoodsList`, data, {
          headers: { accessToken: userdata.token }
        })
        .then(res => {
          this.fullscreenLoading = false;
          if(res.data.success){
            // this.$set(this, "tableData", res.data.pageInfo.list);

            this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
                type: 'success',
                message: res.data.msg
            });
          }else{
            this.$message(res.data.msg)
          }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.status = i
      if(i == 2){
        this.sheng = Number(row.areasId.split(',')[0])
        this.shi = Number(row.areasId.split(',')[1])
        if(this.activeName == 'first'){
            row.enabled +=''
            row.preview = this.imgUrl+row.imgUrl;
            row.previewName = row.goodsName;
            row.imgUrlSlts = [{name:'缩略图',url:`${this.imgUrl+row.imgUrl}`}]
            row.adUrls = [{name:'广告图',url:`${this.imgUrl+row.adUrl}`}]
            this.$set(this, "details", row);
        }else{
            row.enabled +=''
            row.isTop +=''
            row.imgUrls = [{name:'图标',url:`${this.imgUrl+row.imgUrl}`}]
            this.$set(this, "details", row);
        }
      }
      this.dialogFormVisible = true;
      this.getClass()
    },
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          if(this.activeName == 'first'){
            url = `/api-s/deleteRecommendGoods/${row.id}`
          }else{
            url = `/api-s/deleteRecommend/${row.id}`
          }
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  if(this.activeName == 'first'){
                    this.begin();
                  }else{
                    this.classify();
                  }
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      if(this.activeName == 'first'){
        this.begin();
      }else{
        this.classify();
      }
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#recommend .el-input__inner {
  margin: 10px 0;
}
#recommend .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#recommend .el-menu-item.is-active{
  background: none
}
#recommend .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#recommend .el-tag{
  margin-right: 12px;
}
#recommend .block .el-select {
  /* margin: 0 8px; */
  width: 100%
}
#recommend .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#recommend .el-upload-list--picture .el-upload-list__item {
    /* width: 44%; */
    /* float: left; */
    /* margin-right: 2%; */
}
#recommend .el-form-item__content {
    width: 100%;
    line-height: 0px;
    display: flex;
    align-items: center;
}
#recommend .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#recommend .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#recommend .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#recommend .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#recommend .el-dialog__body {
  height: 382px;
}
#nei .el-dialog__body{
  height: 150px !important;
}
#recommend .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#recommend .el-form-item__label{
    width: 122px
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
</style>
